import { Price, VariantInfo } from 'src/types';
import { DistinctVariantValues, IVariantValue } from '../types';
import { FilterSelection } from 'src/components/price-list/types';

const getDistinct = (
  sizesCollection: IVariantValue[],
  colorsCollection: IVariantValue[]
): DistinctVariantValues => {
  const distinctSizes = [
    ...new Map(
      sizesCollection.filter(v => v.size).map(item => [item.size, item])
    ).values(),
  ];
  const distinctColors = [
    ...new Map(
      colorsCollection.filter(v => v.color).map(item => [item.color, item])
    ).values(),
  ];
  return { sizes: distinctSizes, colors: distinctColors };
};

const getValuesFromVariant = (variant: VariantInfo) => {
  const values: IVariantValue[] = [];
  if (variant.size && variant?.sizeSystem) {
    const val = {
      size: variant?.size,
      sizeSystem: variant?.sizeSystem,
    };
    values.push(val);
  }
  if (variant?.colors && variant?.colors?.length > 0) {
    variant?.colors.forEach(color => {
      values.push({ color });
    });
  }
  return values;
};

export const getDistinctVariantValues = (
  offers: Price[]
): DistinctVariantValues => {
  const allValues: IVariantValue[] = [];
  offers.forEach(offer => {
    if (offer?.variantInfo?.size || offer?.variantInfo?.colors) {
      allValues.push(...getValuesFromVariant(offer.variantInfo));
    }
    offer.alternativePrices?.forEach(alt => {
      if (alt?.variantInfo?.size || alt?.variantInfo?.colors) {
        allValues.push(...getValuesFromVariant(alt.variantInfo));
      }
    });
  });
  return getDistinct(allValues, allValues);
};

export const createNewSelection = (
  variant: string | null,
  variantSelection: FilterSelection
) => {
  if (!variant) {
    return [];
  }
  return variantSelection.includes(variant)
    ? variantSelection.filter((v: string) => v !== variant)
    : [...variantSelection, variant];
};

const disableVariantValues = (
  allVariantValues: DistinctVariantValues,
  currentVariantValues: DistinctVariantValues
): DistinctVariantValues => {
  const sizes = allVariantValues.sizes.map(variant => {
    return {
      ...variant,
      disabled: !currentVariantValues.sizes.some(
        current => variant.size === current.size
      ),
    };
  });
  const colors = allVariantValues.colors.map(variant => {
    return {
      ...variant,
      disabled: !currentVariantValues.colors.some(
        current => variant.color === current.color
      ),
    };
  });
  return { sizes, colors };
};

export const getVariantValues = (
  filteredOffers: Price[],
  allOffers: Price[]
): DistinctVariantValues => {
  const filteredVariantsValues = getDistinctVariantValues(filteredOffers);
  const allVariantValues = getDistinctVariantValues(allOffers);
  return disableVariantValues(allVariantValues, filteredVariantsValues);
};
